import { GlobalData } from '../types/config/strings';
import strings from './strings.yaml';

const globalStrings: GlobalData = strings;

export default globalStrings;
